import { ReactNode } from 'react'
import clsx from 'clsx'

/* blocks */
import BlogHeader from '@/cmp/molecules/BlogHeader/Header'
import Seo from '@/molecules/SEO/SEO'
import PromotionalBanner from '@/molecules/PromotionalBanner/PromotionalBanner'
import Footer from '@/cmp/molecules/Footer/Footer'
import { categoriesData } from '@/cmp/molecules/BlogHeader/Header.utils'

/* utils */
import { inter } from '@/styles/fonts/fonts'

interface Meta {
  property: string
  content: string
}

interface Props {
  children: ReactNode
  title: string
  meta?: Meta[]
  canonical?: string
  primaryCta?: { title: string; url: string }
  secondaryCta?: { title: string; url: string }
  tertiaryCta?: { title: string; url: string }
  jsonSchema?: LDJsonSchema[]
  showNavLinks?: boolean
  noIndex?: boolean
  mode?: 'dark' | 'light'
}

function Layout({
  title,
  meta,
  children,
  canonical = '',
  jsonSchema,
  primaryCta,
  secondaryCta,
  tertiaryCta,
  showNavLinks = true,
  noIndex = false,
  mode = 'dark'
}: Props) {
  return (
    <div className={clsx(inter.className, inter.variable)}>
      <Seo
        title={title}
        meta={meta}
        canonical={canonical}
        jsonSchema={jsonSchema}
        noIndex={noIndex}
      />
      <PromotionalBanner />
      <BlogHeader
        showNavLinks={showNavLinks}
        primaryCta={primaryCta}
        secondaryCta={secondaryCta}
        tertiaryCta={tertiaryCta}
        categoriesData={categoriesData}
        mode={mode}
      />
      <main data-test-id="main">{children}</main>

      {showNavLinks && <Footer />}
    </div>
  )
}

export default Layout
